export type AppointmentsGroupBy = 'days' | 'fitters';
